import { createFileRoute } from '@tanstack/react-router'

import { OnboardingForm } from '#components/features/auth/onboarding-form'

export const Route = createFileRoute('/_auth/onboarding')({
  head: () => ({
    meta: [
      { title: 'Configurar estabelecimento | UseComanda' },
      {
        name: 'description',
        content: 'Configure seu estabelecimento para começar a operar.',
      },
    ],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="w-full max-w-sm">
        <OnboardingForm />
      </div>
    </div>
  )
}
